import React, { useState, useEffect } from 'react';
import moment from 'moment';
import styled from 'styled-components';

interface Props {
  sData: any;
  setSelectDate: any;
}

const CustomCalender: React.FC<Props> = (props) => {
  const [getMoment, setMoment] = useState(moment());
  const currentMonth = getMoment.format('YYYY-MM');
  props.setSelectDate(currentMonth);
  const today = getMoment;
  const firstWeek = today.clone().startOf('month').week();
  const lastWeek =
    today.clone().endOf('month').week() === 1 ? 53 : today.clone().endOf('month').week();
  const salesData: any = props.sData;

  // 달력이동
  // const moveForgetIdPage = (date) => {
  //   navigate('/loginIdForget?=date=' + date);
  // };
  // -> 링크에서 date추출 후 date있으면 tab state변경해서 date 넘기기

  const calendarArr = () => {
    let result: any = [];
    let week = firstWeek;
    for (week; week <= lastWeek; week++) {
      result = result.concat(
        <tr key={week}>
          {Array(7)
            .fill(0)
            .map((data, index) => {
              let days = today.clone().startOf('year').week(week).startOf('week').add(index, 'day');
              let apiKey: string = days.format('YYYY-MM-DD');
              let dayOfWeek = days.day();
              if (
                moment().format('YYYYMMDD') === days.format('YYYYMMDD') &&
                days.format('MM') === today.format('MM')
              ) {
                // 당일
                return (
                  <td key={index} className="day today">
                    <div className="todayFontWrap">
                      <span>{days.format('D')}</span>
                    </div>
                    <div>
                      <p>{salesData && salesData[apiKey] && salesData[apiKey]?.net_sales_cnt}건</p>
                      <p className="price">
                        {salesData &&
                          salesData[apiKey] &&
                          salesData[apiKey]?.net_sales?.toLocaleString()}
                        원
                      </p>
                    </div>
                  </td>
                );
              } else if (days.format('MM') !== today.format('MM')) {
                // 해당월에 포함되지 않는날
                return (
                  <td key={index} className="day previousMonth">
                    <span>{days.format('D')}</span>
                  </td>
                );
              } else {
                // 해당월에 포함되는 날
                return (
                  <td key={index} className="currentMonth">
                    <div className="day monthDate">
                      <span
                        style={{
                          color: dayOfWeek === 0 ? '#FF3542' : '#969696',
                        }}>
                        {days.format('D')}
                      </span>
                      {salesData && salesData[apiKey] && (
                        <div>
                          <p>{salesData[apiKey] && salesData[apiKey]?.net_sales_cnt}건</p>
                          <p className="price" style={{ width: '100%', wordBreak: 'break-all' }}>
                            {salesData[apiKey] && salesData[apiKey]?.net_sales?.toLocaleString()}원
                          </p>
                        </div>
                      )}
                    </div>
                  </td>
                );
              }
            })}
        </tr>,
      );
    }
    return result;
  };

  return (
    <Style>
      <div className="contentContainer wide">
        <div className="title">
          <div className="control">
            <button
              onClick={() => {
                setMoment(getMoment.clone().subtract(1, 'month'));
              }}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_left.svg`} alt="이전달보기 버튼" />
            </button>
            <h2>{today.format('MM월')}</h2>
            <button
              onClick={() => {
                let next = getMoment.clone().add(1, 'month');

                setMoment(next);
              }}>
              <img src={`${process.env.PUBLIC_URL}/svg/ic_arrow_right.svg`} alt="다음달보기 버튼" />
            </button>
          </div>
          <div className="titleWrap">
            <h2>
              이번 달 예상 수익은 <span>{salesData?.total_amount?.toLocaleString()}원</span> 입니다
            </h2>
            <h4>({salesData?.total_cnt}건)</h4>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <th>일</th>
              <th>월</th>
              <th>화</th>
              <th>수</th>
              <th>목</th>
              <th>금</th>
              <th>토</th>
            </tr>
          </thead>
          <tbody>{calendarArr()}</tbody>
        </table>
      </div>
    </Style>
  );
};

export default CustomCalender;

const Style = styled.div`
  .title {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 40px;
    margin-bottom: 40px;
  }
  .titleWrap {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    h2 {
      color: #555555;
    }
    span {
      color: #4dd2ae;
    }
    h4 {
      color: #a7a7a7;
      font-weight: 500;
    }
  }

  /* month select */
  .control {
    display: flex;
    align-items: center;
    gap: 20px;

    h2 {
      color: #333333;
      font-weight: 600;
    }
    button {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  table,
  td,
  th {
    border-collapse: collapse;
  }
  table {
    width: 100%;
  }
  th {
    padding: 2px 6px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    color: #979797;
    text-align: right;
  }
  td {
    width: calc(100% / 7);
    border: 1px solid #d9d9d9;
    text-align: right;
    vertical-align: baseline;
  }

  .day {
    min-height: 100px;
    max-height: 100px;
    padding: 1px 4px;
    div {
      height: 75%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: flex-end;
    }
    span {
      padding: 4px;
      color: #979797;
      font-size: 14px;
      font-weight: 500;
    }
    p {
      text-align: right;
      color: #40977f;
      font-size: 16px;
      font-weight: 600;
    }
    p.price {
      color: #979797;
    }
  }

  /* 당일 */
  .today {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    background: #ecf5f3;
    z-index: 99;
    position: relative;
    outline: 3px solid #4dd2ae;
    border-radius: 3px;

    .todayFontWrap {
      margin-top: -2px;
      position: relative;
      width: 24px;
      height: 25px;
      background: #4dd2ae;
      color: #fff;
    }
    .todayFontWrap:before,
    .todayFontWrap:after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-top: 8px solid transparent;
      border-bottom: 8px solid transparent;
    }
    .todayFontWrap::after {
      bottom: -8px;
      border-left: 12px solid #4dd2ae;
      border-right: 12px solid #4dd2ae;
    }
    span {
      color: #fff;
    }
  }
  /* 해당월 */
  .monthDate {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    text-align: right;
  }

  /* 전월 */
  .previousMonth {
    background: #f7f7f7;
    text-align: right;
    span {
      color: #cecece;
    }
  }

  @media (max-width: 900px) {
    .title {
      align-items: flex-start;
    }

    td {
      border: none;
    }
    th {
      padding: 2px;
      font-size: 14px;
      line-height: 20px;
      color: #555555;
    }
    .day {
      min-height: 70px;
      max-height: 70px;
      padding: 1px;
      span {
        font-size: 12px;
      }
      p {
        text-align: right;
        font-size: 12px;
        line-height: 18px;
        font-weight: 500;
      }
      p.price {
        font-size: 10px;
      }
    }

    .today {
      outline: 0px solid #4dd2ae;

      .todayFontWrap {
        margin-top: -1px;
        margin-right: -1px;
        width: auto;
        height: auto;
        border-radius: 3px;
      }
      .todayFontWrap:before,
      .todayFontWrap:after {
        display: none;
      }
      span {
        background: #4dd2ae;
        color: #fff;
      }
    }
  }
`;
